/* eslint no-return-assign: "off", max-len: "off" */
import React from 'react';
import Dialog from 'material-ui/Dialog';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import Settings from 'material-ui/svg-icons/action/settings';
import Delete from 'material-ui/svg-icons/action/delete';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';

import ResultHistory from './ResultHistory';
import SpeechRecognitionResult from './SpeechRecognitionResult';
import Gauge from './Gauge';
import CreateExerciseForm from './CreateExerciseForm';

import apiErrors from '../modules/apierrors';
import getErrors from '../modules/geterrors';
import perm from '../modules/auth';
import { createExercise, updateExercise, deleteExercise } from '../actions/actions';

import './TTSInput.css';

class TTSInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      saveOpen: false,
      modifyOpen: false,
      deleteOpen: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    // If an exercise creation request is successful and the save dialog is open,
    // close the dialog.
    if ((this.props.exercises.hasSaved === false && nextProps.exercises.hasSaved === true) ||
      (this.props.exercises.hasUpdated === false && nextProps.exercises.hasUpdated === true)
    ) {
      this.setState({ saveOpen: false });
    }
  }

  // preventDefault is needed, since paste event triggers a change event also,
  // so both handleInput and handlePaste would be executed without it. It
  // would result in a mess.
  handleInput(e) {
    e.preventDefault();
    this.props.dispatch(this.props.updateSource(this.textInput.value));
  }

  handlePaste(e) {
    e.preventDefault();
    this.props.dispatch(this.props.launchText(e.clipboardData.getData('text/plain')));
  }

  saveExercise = (name, language, text, mode, saveToGroup) => {
    this.props.dispatch(createExercise({ name, language, text, mode, saveToGroup }));
  }

  updateExercise = (id, body) => {
    this.props.dispatch(updateExercise(id, body));
  }

  deleteExercise = (id) => {
    this.setState({ deleteOpen: false });
    this.props.dispatch(deleteExercise(id));
    this.props.clearExercise();
  }

  handleUpdateExercise = (id, exercise) => {
    this.props.dispatch(updateExercise(id, exercise));
  }

  handleSettings = (event, value) => {
    switch (value) {

    case 'save':
      this.setState({ saveOpen: true });
      break;
    case 'delete':
      this.setState({ deleteOpen: true });
      break;
    case 'close':
      this.props.clearExercise();
      break;
    default:
      break;
    }
  }

  render() {
    const { auth, exercises } = this.props;

    perm.setPermissions(auth.user.permissions);
    perm.setRole(auth.user.role);

    const { validationErrors } = getErrors(this.props.errors);
    const nameErrorMessage = apiErrors[validationErrors.name] || validationErrors.name;
    const textErrorMessage = apiErrors[validationErrors.text] || validationErrors.text;

    const p = this.props;
    const text = p.texts.activeText !== null
            ? p.texts[p.text.activeText].source
            : '';

    const resultHistory = p.texts[p.text.activeText].results || [];

    const result = (p.text.activeText !== null && p.texts[p.text.activeText].results.length !== 0)
            ? p.texts[p.text.activeText].results[p.texts[p.text.activeText].results.length - 1].result.result
            : '';
    const score = (p.text.activeText !== null && p.texts[p.text.activeText].results.length !== 0)
            ? p.texts[p.text.activeText].results[p.texts[p.text.activeText].results.length - 1].score
            : '';

    const scoreByWord = (p.text.activeText !== null && p.texts[p.text.activeText].results.length !== 0)
            ? p.texts[p.text.activeText].results[p.texts[p.text.activeText].results.length - 1].scoreByWord
            : '';

    let removeText;
    let charIndicator;
    let charClass;

    const isGroupExercise = (exercises.activeExercise !== null && exercises.exercises[exercises.activeExercise].group_id !== null);
    const hasPermission = perm.can('control-group-exercises');

    let iconMenuStyle = {};
    // The icon  menu itself cannot be disabled, so
    // change its color so it doesn't pop out.
    if (!this.props.isStopped()) {
      iconMenuStyle = {
        color: '#bbb',
      };
    }

    const settings = (
      <span className="settings-menu">
        <IconMenu
          iconStyle={iconMenuStyle}
          iconButtonElement={<IconButton><Settings /></IconButton>}
          onChange={this.handleSettings}
        >
          <MenuItem value="save" disabled={!this.props.isStopped() || (isGroupExercise && !hasPermission)} primaryText="Edit exercise" />
          <MenuItem value="delete" disabled={!this.props.isStopped() || exercises.activeExercise === null || (isGroupExercise && !hasPermission)} primaryText="Delete exercise" />
          <MenuItem value="close" disabled={!this.props.isStopped() || (exercises.activeExercise === null && text.length === 0)} primaryText="Close exercise" />

        </IconMenu>
      </span>
    );

    const saveActions = [
      <FlatButton
        label="Cancel"
        primary
        onTouchTap={() => this.setState({ saveOpen: false })}
      />];

    const exercise = (this.props.exercises.activeExercise !== null) ? this.props.exercises.exercises[this.props.exercises.activeExercise] : null;

    const saveDialog = (
      <Dialog title="Edit exercise" actions={saveActions} modal={false} open={this.state.saveOpen} onRequestClose={() => this.setState({ saveOpen: false })} autoScrollBodyContent>
        <CreateExerciseForm exercise={exercise} canSaveToGroup={perm.can('control-group-exercises')} language={this.props.language} text={this.props.text} mode={this.props.mode} disabled={!this.props.isStopped()} isWaiting={this.props.isWaiting} nameErrorMessage={nameErrorMessage} textErrorMessage={textErrorMessage} updateExercise={this.updateExercise} saveExercise={this.saveExercise} />
      </Dialog>
    );


    let deleteDialog;


    if (p.exercises.activeExercise !== null) {
      const delLabel = this.props.isWaiting.EXERCISE_DELETE ? <CircularProgress size={20} /> : 'Yes, delete exercise';

      const deleteActions = [
        <FlatButton
          label="No, cancel"
          primary
          onTouchTap={() => this.setState({ deleteOpen: false })}
        />,
        <FlatButton
          label={delLabel}
          primary
          onTouchTap={() => this.deleteExercise(p.exercises.exercises[p.exercises.activeExercise].id)}
        />];

      deleteDialog = (
        <Dialog
          actions={deleteActions}
          modal={false}
          open={this.state.deleteOpen}
          onRequestClose={() => this.setState({ deleteOpen: false })}
        >
        Are you sure you want to delete this exercise?
          <br /><br />
          {p.exercises.exercises[p.exercises.activeExercise].name}<br /><br />
          {p.exercises.exercises[p.exercises.activeExercise].text}
        </Dialog>
      );
    }

    if (
      p.isStopped()
      && p.text.activeText !== null
      && (!exercise || exercise.group_id === null || perm.can('control-group-exercises'))
    ) {
      removeText = (
        <span className="remove-text">
          <IconButton tooltip="Clear this sentence" disabled={text.length === 0} onClick={(e) => { e.preventDefault(); p.dispatch(p.spliceSentence()); }}>
            <Delete />
          </IconButton>
        </span>
      );
    }

    if (text.length > 150) {
      if (text.length === 200) {
        charClass = 'maximum';
      }
      charIndicator = <span className={`charIndicator ${charClass}`}>{text.length}</span>;
    }

    return (
      <form className="pronounce-tts-form card">
        <span className="settings-area">
          {settings}
          {this.state.saveOpen && saveDialog}
          {deleteDialog}
        </span>
        {removeText}
        <textarea
          id="pronounce-source-input"
          maxLength="200"
          readOnly={!p.isStopped() || (p.exercises.activeExercise !== null && !perm.can('control-group-exercises'))}
          value={text}
          ref={input => this.textInput = input}
          onChange={e => this.handleInput(e)}

          onPaste={e => this.handlePaste(e)}
          placeholder="Write or paste your text here, then listen and try to pronounce it yourself."
        />
        <hr className="tts-divider" />
        <SpeechRecognitionResult isRecording={this.props.isRecording} result={result} scoreByWord={scoreByWord} />
        <Gauge isStopped={this.props.isStopped()} score={score} />
        <ResultHistory text={text} resultHistory={resultHistory} />
        {charIndicator}
      </form>
        );
  }
}

export default TTSInput;



// WEBPACK FOOTER //
// ./src/components/TTSInput.js